import React, { useEffect, useState } from 'react';
import { CenterBox, fetchJSON } from './Utils';
import {
  useParams
} from "react-router-dom";
import SignIn from "./SignIn.js";
import Auth from './Auth';
import * as Sentry from "@sentry/react";

import firebase from './Firebase.js';

function Invite(props) {
  const [invalid, setInvalid] = useState(false);
  const [alreadyAccess, setAlreadyAccess] = useState(false);
  const [user, setUser] = useState(null);
  const [redirected, setRedirected] = useState(false);
  const [loginError, setLoginError] = useState(false);

  let { code } = useParams();

  useEffect(() => {
    async function checkUser() {
      firebase.auth().onAuthStateChanged(async userAuth => {
        if (userAuth && !userAuth.isAnonymous) {
          console.log("FROM SIGNIN App User state changed: " + (userAuth ? userAuth.email : null));
          setRedirected(true);
          setUser(userAuth);

          let data = await Auth.fetchWithIdToken("/api/access", {});
          if (data.success) {
            setAlreadyAccess(true);
            setRedirected(false);
            Sentry.captureMessage("User already has access from invite code");
            setTimeout(() => {
              window.location.href = "/app";
            }, 3000);
          } else {
            // consume the invite and redirect
            let consumeData = await Auth.fetchWithIdToken(`/api/invite/consume/${code}`, {});

            if (consumeData.success) {
              window.location.href = "/app";
            } else {
              setInvalid(true);
              Sentry.captureMessage("Invalid invite code");
            }
          }
        }
      });
    }

    async function checkCode(c) {
      let response = await fetchJSON("/api/invite/" + c);

      if (!response.ok) {
        setInvalid(true);
      }
    }

    // Set the invite code so that if user decides to use email sign they can generate a link directly with this code
    if (code) {
      window.localStorage.setItem("inviteUrl", encodeURI(window.location.href + "#redirect"));
    }

    checkCode(code);
    checkUser();

    if (window.location.hash === "#redirect") {
      // we know they came back from signing in
      // give it a moment to wait to check
      setRedirected(true);
      window.location.hash = "";

      Sentry.setContext("inviteRedirect", {
        code: code,
      });

      setTimeout(() => {
        Sentry.captureMessage("Failed to authenticate after invite redirect after 10 seconds");
        setRedirected(false);
        setLoginError("Looks like something went wrong with Google Login. Please try again. If this persists, please email us at hi@sudowrite.com.");
      }, 10000);
    }

  }, []);

  return (
    <>
      {invalid &&
        <SignIn
          title={"You're invited to join Sudowrite 🎉"}
          description={"Looks like you already accepted this invite, perhaps on another device or browser. Sign in to access your account."}
          error={loginError}
        />
      }

      {!invalid &&
        <>
          {redirected &&
            <CenterBox noTitle={true}>
              <h2>Checking account...</h2>
            </CenterBox>
          }
          {!redirected &&
            <>
              {alreadyAccess &&
                <CenterBox>
                  <div className="invite">
                    <h2>You already have an account under {user.email}</h2>
                    <p>Redirecting you back to <a href="/app">home</a></p>
                  </div>
                </CenterBox>
              }
              {!alreadyAccess &&
                <SignIn
                  title={"You're invited to join Sudowrite 🎉"}
                  description={"Get started by signing in"}
                  error={loginError}
                />
              }
            </>
          }
        </>
      }
    </>
  );
}

export default Invite;
